import CoveragePanel from "./CoveragePanel";

/** Auto-detected pitch-deck section coverage. */
export default function PitchDeckCoveragePanel() {
  return (
    <CoveragePanel
      endpoint="/founder/readiness/pitch-deck-coverage"
      hasFlag="has_pitch_deck"
      title="Pitch Deck Coverage"
      testId="pitch-deck-coverage-card"
      emptyTitle="No pitch deck uploaded yet"
      emptyBody="Upload your funder deck (PDF or PPTX) and we'll auto-detect each canonical section — Problem, Solution, Market, Traction, Team, The Ask — so you know what to strengthen before reaching out to funders."
      uploadCtaLabel="Upload pitch deck"
      serviceFocus="pitch_deck"
      serviceCtaLabel="Have Clinq build my pitch deck"
    />
  );
}
